// extracted by mini-css-extract-plugin
module.exports = {"astroContainer":"AstroContainer_astroContainer__E_7sf","liveWrapper":"AstroContainer_liveWrapper__GJStR","postCardWrapper":"AstroContainer_postCardWrapper__oLmd9"};